export var MS_TRANSACTION_TYPE_KEY = 'TransactionType';
export var TABLE_ROW_HEIGHT = 50;
export var KEY_STROKES = {
  ENTER: 'Enter',
  TAB: 'Tab'
};
export var CUSTOMER_TYPE_FILTERS = {
  INDIVIDUAL: 'Individual'
};
export var REBATE_KEY = {
  NAME_DISPLAY: 'NameDisplay',
  NUMBER: 'Number',
  IDENT_CODE: 'IdentCode',
  PAYMENT_TYPE: 'PaymentType'
};
export var FIELD_IDS = {
  PROGRAM_NUMBER: 'programNumber',
  PROGRAM_CODE: 'programCode',
  CERTIFICATE_NUMBER: 'certificateNumber',
  REBATE_TYPE: 'rebateType',
  REBATE_AMOUNT: 'rebateAmount',
  PAYMENT_TYPE_CODE: 'paymentTypeCode'
};